import * as R from 'ramda'
import * as recompose from 'recompose'
import LazyLoad from 'react-lazyload'
import PropTypes from 'prop-types'
import React from 'react'

import * as t from '@rushplay/theme'
import styled from '@emotion/styled'
import { Link, truncate } from '@rushplay/common'
import { css } from '@emotion/core'

import { LoginRequiredOverlay } from '../login-required-overlay'
import { getGameUrl } from '../../utils/get-game-url'

const GameLink = R.compose(
  recompose.branch(props => R.isNil(props.to), recompose.renderComponent('a'))
)(Link)

const Wrapper = styled(GameLink)`
  position: relative;
  display: inline-block;
  box-shadow: ${t.boxShadow(0)};
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  margin: 3px;
  width: 100%;
`

const LiveLabel = styled.div`
  bottom: 4px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  color: ${t.color('white')};
  font-family: ${t.font('head')};
  font-size: ${t.fontSize(0)};
  font-weight: 700;
  padding: 4px ${t.spacing(0)};
  position: absolute;
  background-color: ${t.color('gray')};
  white-space: nowrap;
`

const ImageBackground = styled.div`
  width: 100%;
  height: 150px;
  background-size: cover;
  background-position: center;

  ${props => css`
    background-image: url('${props.backgroundUrl}');
  `}
`

export function LobbyLiveGameTile(props) {
  const fallbackThumbnail = `data:image/svg+xml;utf8,<svg width="190" height="160" xmlns="http://www.w3.org/2000/svg" version="1.1"><rect height="160" width="190" stroke-width="1" stroke-dasharray="5,5" fill="white" stroke="lightgray" stroke-linecap="round" rx="4" ry="4"/><text x="95" y="80" text-anchor="middle">${props.game.title}</text></svg>`

  return (
    <LazyLoad once height="160px">
      <Wrapper to={getGameUrl(props.game.id)}>
        <ImageBackground
          backgroundUrl={
            props.game.imageUrl ? props.game.imageUrl : fallbackThumbnail
          }
        />
        {props.game.id && (
          <LiveLabel>{truncate(14, props.game.title)}</LiveLabel>
        )}
        {!props.authenticated && <LoginRequiredOverlay />}
      </Wrapper>
    </LazyLoad>
  )
}

LobbyLiveGameTile.defaultProps = {
  authenticated: false,
  game: { title: '' },
}

LobbyLiveGameTile.propTypes = {
  authenticated: PropTypes.bool,
  game: PropTypes.object,
  translate: PropTypes.func.isRequired,
  imageUrl: PropTypes.string,
}
